import http from '../utilities/http';
import config from '../config';

/**
 * Check if account name unique.
 */
export async function is_account_name_unique(name) {
  return await http.get(config.endpoints.accounts.checkIfUnique + '/' + name);
}

/**
 * Check if address wallet is unique.
 */
export async function is_wallet_address_unique(address) {
  return await http.get(config.endpoints.accounts.checkUniqueAddress + '/' + address);
}

/**
 * Check if api_key unique.
 */
export async function is_api_key_unique(api_key) {
  return await http.get(config.endpoints.accounts.checkUniqueAPIKey + '/' + api_key);
}

/**
 * Check if api_secret is unique.
 */
export async function is_api_secret_unique(api_secret) {
  return await http.get(config.endpoints.accounts.checkUniqueSecret + '/' + api_secret);
}

/**
 * Check if provider is unique.
 */
export async function is_cefi_provider_unique(provider) {
  return await http.get(config.endpoints.accounts.checkUniqueCefiProvider + '/' + provider);
}

/**
 * Check if email is unique.
 */
export async function is_email_unique(email) {
  return await http.get(config.endpoints.users.checkIfUniqueEmail + '/' + email);
}

/**
 * Check if contact name is unique.
 */
export async function is_contact_name_unique(value, name) {
  if (value.type === 'Update') {
    return await http.get(config.endpoints.contact.checkIfUniqueName + '/' + name, {
      params: { current_name: value.current_name },
    });
  } else {
    return await http.get(config.endpoints.contact.checkIfUniqueName + '/' + name);
  }
}

/**
 * Check if contact address is unique.
 */
export async function is_contact_address_unique(value, address) {
  if (value.type === 'Update') {
    return await http.get(config.endpoints.contact.checkIfUniqueAddress + '/' + address, {
      params: { current_address: value.current_address },
    });
  } else {
    return await http.get(config.endpoints.contact.checkIfUniqueAddress + '/' + address);
  }
}

/**
 * Check if contact name is unique.
 */
export async function is_contract_name_unique(value, name) {
  if (value.type === 'Update') {
    return await http.get(config.endpoints.contract.checkIfUniqueName + '/' + name, {
      params: { current_name: value.current_name },
    });
  } else {
    return await http.get(config.endpoints.contract.checkIfUniqueName + '/' + name);
  }
}

/**
 * Check if contact address is unique.
 */
export async function is_contract_address_unique(value, address) {
  if (value.type === 'Update') {
    return await http.get(config.endpoints.contract.checkIfUniqueAddress + '/' + address, {
      params: { current_address: value.current_address },
    });
  } else {
    return await http.get(config.endpoints.contract.checkIfUniqueAddress + '/' + address);
  }
}

/**
 * Check if metaMask address is unique.
 */
export async function is_metaMask_address_unique(value) {
  return http.get(config.endpoints.address.metamask + '/' + value);
}
